import React from "react";
import { Route, Redirect } from "react-router-dom";
import Cookies from 'js-cookie';
import { useAuth } from "../helpers"
import { ACCESS_TOKEN } from "../constants";

function PrivateRoute({ component: Component, headerTitle, ...rest }) {
  const isAuthenticated = useAuth()
  const accessToken = Cookies.get(ACCESS_TOKEN);

  return (
    <Route
      {...rest}
      render={(props) =>
        accessToken ? (
          <div>
            <Component {...props} />
          </div>
        ) : (
            <Redirect to="/" />
          )
      }
    />
  )
}

export default PrivateRoute;
